import React from 'react';
import { Box } from '@mui/material';
import { SymbolItem } from './SymbolItem';
import { Strategy } from '../../../shared/types/generated';

type SymbolListProps = {
  strategies: Strategy[]
}

export const SymbolList: React.FC<SymbolListProps> = (
  {
    strategies = [],
  }) => {
  return (
    <Box overflow='auto'>
      <Box display='flex' py={1}>
        {strategies.map((strategy) => (
          <SymbolItem strategy={strategy} />
        ))}
      </Box>
    </Box>
  );
};
